import * as Widgets from '@mm/constants/widgets';
import WidgetEntity from '../WidgetEntity';

export default class VideoWidget extends WidgetEntity {
  static make(pageId: number, sortOrder: number) {
    const widget = {
      ...super.make(pageId, Widgets.VIDEO, 'Untitled video', sortOrder),
      config: {
        title: 'Untitled video',
        // uploadId: null,
        assetId: null,
      },
      title: '',
    };

    // @ts-ignore
    delete widget.title;

    return widget;
  }
}
